"use client";

import { useLayoutEffect } from "react";
import {
  persistCoursePreviewToken,
  resolveCoursePreviewTokenForRequest,
} from "@/lib/course-preview";
import { setCoursePreviewFetcherToken } from "@/lib/api";

/** Captures `?preview=` into session + memory and strips it from the address bar. */
export function CoursePreviewSync({ token }: { token: string | null }) {
  useLayoutEffect(() => {
    const fromUrl = resolveCoursePreviewTokenForRequest();
    const t = token ?? fromUrl;
    if (!t?.trim()) return;
    setCoursePreviewFetcherToken(t.trim());
    persistCoursePreviewToken(t.trim());
    const url = new URL(window.location.href);
    if (!url.searchParams.has("preview")) return;
    url.searchParams.delete("preview");
    const qs = url.searchParams.toString();
    window.history.replaceState(null, "", `${url.pathname}${qs ? `?${qs}` : ""}${url.hash}`);
  }, [token]);

  return null;
}
